import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.14 3.811a.7.7 0 0 1 .987 0l4.667 4.647a.7.7 0 0 1 0 .992l-5.566 5.543H16.3a.7.7 0 1 1 0 1.4H7.2a.7.7 0 0 1-.494-.204l-3.5-3.486a.7.7 0 0 1 0-.992l7.933-7.9ZM9.243 14.993l.93-.927L6.5 10.407l-1.808 1.8 2.797 2.786h1.755ZM7.492 9.419l3.675 3.66 4.141-4.125-3.675-3.659L7.492 9.42Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
